import { render } from "./menuComponent.vue?vue&type=template&id=a80dff76&ts=true"
import script from "./menuComponent.vue?vue&type=script&lang=ts"
export * from "./menuComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__